












































































import {Component, Prop} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import OriginatorRulesFilter from "@/components/Rules/OriginatorRules/OriginatorRulesFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {OriginatorRuleItem} from "@/store/rules/originator_rules/types";
import {MsgTransports} from "@/store/types";

@Component({components:{OriginatorRulesFilter, ScrollButton}})
export default class OriginatorRules extends BaseItemsPage<OriginatorRuleItem> {
  @Prop() transport!: MsgTransports;
  @Getter("originatorRules") originatorRulesResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'id',
    'service_provider',
    'partner',
    'originator',
  ];

  getData(): any {
    return this.originatorRulesResponse;
  }
}
